import { ReviewCreationData } from '../../../types/review-creation-data';
import { getReviewSubmissionClientData } from '../../helper/get-review-submission-client-data';
import { ReviewFormData } from './parse-review-form-data';

type GetCreateReviewRequestDataParams = {
    rootElement: Pick<HTMLElement, 'querySelector' | 'dataset'>;
    reviewFormData: ReviewFormData;
};

export function createReviewCreationData({ rootElement, reviewFormData }: GetCreateReviewRequestDataParams): ReviewCreationData {
    const clientData = getReviewSubmissionClientData({ rootElement });
    if (clientData.status !== 'CAN_SUBMIT') throw new Error('Review submission data is not submittable');
    if (reviewFormData.anonymous === undefined) throw new Error('No anonymous-review information selected');
    return {
        variationId: clientData.variation.id,
        review: {
            anonymous: reviewFormData.anonymous,
            numericRatings: createNumericRatings(reviewFormData),
            textRatings: createTextRatings(reviewFormData),
        },
        images: reviewFormData.images,
    };
}

function createTextRatings(reviewFormData: ReviewFormData) {
    const textRatings: ReviewCreationData['review']['textRatings'] = [];
    if (reviewFormData.title !== undefined) {
        textRatings.push({
            identifier: 'title',
            value: reviewFormData.title,
        });
    }
    if (reviewFormData.text !== undefined) {
        textRatings.push({
            identifier: 'general',
            value: reviewFormData.text,
        });
    }
    return textRatings;
}

function createNumericRatings(reviewFormData: ReviewFormData) {
    if (reviewFormData.stars === undefined) throw new Error('No rating selected');

    const numericRatings: ReviewCreationData['review']['numericRatings'] = [
        {
            identifier: 'general_rating',
            value: reviewFormData.stars,
        },
    ];
    if (reviewFormData.fit !== undefined) {
        numericRatings.push({
            identifier: 'fits_as_specified',
            value: reviewFormData.fit,
        });
    }
    if (reviewFormData.quality !== undefined) {
        numericRatings.push({
            identifier: 'product_quality',
            value: reviewFormData.quality,
        });
    }
    if (reviewFormData.designAppearance !== undefined) {
        numericRatings.push({
            identifier: 'design_appearance',
            value: reviewFormData.designAppearance,
        });
    }
    if (reviewFormData.assembly !== undefined) {
        numericRatings.push({
            identifier: 'assembly',
            value: reviewFormData.assembly,
        });
    }
    if (reviewFormData.comfort !== undefined) {
        numericRatings.push({
            identifier: 'comfort',
            value: reviewFormData.comfort,
        });
    }
    if (reviewFormData.pricePerformanceRatio !== undefined) {
        numericRatings.push({
            identifier: 'price_performance_ratio',
            value: reviewFormData.pricePerformanceRatio,
        });
    }
    if (reviewFormData.recommended !== undefined) {
        numericRatings.push({
            identifier: 'recommended',
            value: reviewFormData.recommended ? 1 : 0,
        });
    }
    return numericRatings;
}
